











import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class EditPromotionView extends Vue {
  @Prop({ default: () => () => [] })
  public routes!: () => any;

  public get i18n() {
    return {
      title: this.$t("_action.edit_object", {
        object: (this.$t("_.promotion") as string).toLowerCase()
      })
    };
  }
}
